import { useFormContext } from 'react-hook-form'

import { omitEmptyValues } from 'app/utils/helpers/form.helpers'

const useProductsFiltersControl = <T>() => {
  const methods = useFormContext()
  const { getValues, reset } = methods
  const { p, ...values } = getValues() as T & { p: string }

  const hasFilters = Object.values(omitEmptyValues(values)).length === 0

  const onClearFilter = () => reset({ ...(p && { p }) })

  return { hasFilters, onClearFilter, methods }
}

export default useProductsFiltersControl
